export * from './product-short.slice';
